<template>
  <div>
    <el-table :data="batchSwitchList">
      <el-table-column prop="name" label="Job Name"> </el-table-column>
      <el-table-column label="All Pass">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.allPass"
            @change="handleSwitchChange(scope.row.name, 'allPass', $event)"
            active-color="#13ce66"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="One Batch">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.oneBatch"
            @change="handleSwitchChange(scope.row.name, 'oneBatch', $event)"
            active-color="#13ce66"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="In Progress">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.inProgress"
            @change="handleSwitchChange(scope.row.name, 'inProgress', $event)"
            active-color="#13ce66"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="Batch Size">
        <template slot-scope="scope">
          <a @click="handleBatchSizeChange(scope.row.name)">
            {{ scope.row.batchSize }}<i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'BatchSwitchList',
  methods: {
    ...mapActions('walletSwitchSetting', [
      'batchList',
      'updateJobBatchSize',
      'updateBatchSwitchStatus'
    ]),
    handleSwitchChange(name, switchType, status) {
      this.$confirm('确认进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.updateBatchSwitchStatus({ name, switchType, status }).then(
            () => {
              this.$message.success('操作成功！');
              this.batchList();
            }
          );
        }
      );
    },
    handleBatchSizeChange(name) {
      this.$prompt('请输入size', '提示', {
        inputValidator: value => {
          return !value || !value.trim() ? '请输入size' : true;
        }
      }).then(({ value }) => {
        this.updateJobBatchSize({ name, size: Number(value) }).then(() => {
          this.$message.success('操作成功！');
          this.batchList();
        });
      });
    }
  },
  computed: {
    ...mapState('walletSwitchSetting', ['batchSwitchList'])
  },
  created() {
    this.batchList();
  }
};
</script>

<style></style>
